import { Task } from './app-task.model';

export class TaskQueueResponse {
  tasks: Task[];
  totalTasks: number;
}
